import { render } from "./meusPedidos.vue?vue&type=template&id=4b9c1f91"
import script from "./meusPedidos.vue?vue&type=script&lang=js"
export * from "./meusPedidos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projetos_Somasys\\Delivery\\DeliverySoma-SOLO.2023.10.27\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__